<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M9.8 2C8.63305 2 7.51389 2.46357 6.68873 3.28873C5.86357 4.11389 5.4 5.23305 5.4 6.4C5.4 7.56695 5.86357 8.68611 6.68873 9.51127C7.51389 10.3364 8.63305 10.8 9.8 10.8C10.967 10.8 12.0861 10.3364 12.9113 9.51127C13.7364 8.68611 14.2 7.56695 14.2 6.4C14.2 5.23305 13.7364 4.11389 12.9113 3.28873C12.0861 2.46357 10.967 2 9.8 2ZM18.05 11.9C15.3 11.9 13.1 14.1 13.1 16.85C13.1 19.6 15.3 21.8 18.05 21.8C20.8 21.8 23 19.6 23 16.85C23 14.1 20.8 11.9 18.05 11.9ZM9.8 13C4.938 13 1 16.4605 1 18.5C1 20.5395 12 20.7 12 20.7C11.6369 19.8286 10.9471 17.794 10.9471 16.85C10.9519 15.5457 11.3211 14.1136 12 13C11.307 12.912 10.548 13 9.8 13ZM18.05 13.55C19.876 13.55 21.35 15.024 21.35 16.85C21.35 17.466 21.185 18.038 20.888 18.5L16.4 14.012C16.862 13.715 17.434 13.55 18.05 13.55ZM15.212 15.2L19.7 19.688C19.238 19.985 18.666 20.15 18.05 20.15C16.224 20.15 14.75 18.676 14.75 16.85C14.75 16.234 14.915 15.662 15.212 15.2Z"
      :fill="color"
    />
  </svg>
</template>
